import React from "react";
import { Menu } from "@headlessui/react";
import DropdownItem from "./DropdownItem/DropdownItem";
import styles from "./Dropdown.module.css";

interface Props {
    children: React.ReactNode;
}

const Dropdown = ({ children }: Props) => (
    <Menu.Items as="ul" className={styles.list}>
        {children}
    </Menu.Items>
);

Dropdown.Item = DropdownItem;

export default Dropdown;
